/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validationerrormessage2Inputs */

const en_validationerrormessage2 = /** @type {(inputs: Validationerrormessage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The entered data is invalid.`)
};

const de_validationerrormessage2 = /** @type {(inputs: Validationerrormessage2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die eingegebenen Daten sind ungültig.`)
};

/**
* | output |
* | --- |
* | "The entered data is invalid." |
*
* @param {Validationerrormessage2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const validationerrormessage2 = /** @type {((inputs?: Validationerrormessage2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validationerrormessage2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validationerrormessage2(inputs)
	return de_validationerrormessage2(inputs)
});
export { validationerrormessage2 as "validationErrorMessage" }